// src/config/clientThemes.js

import DoktorLogo from '../images/doktorlogo.png';
import mainLogo from '../images/black_letters_with_blue_shadow.svg';
import {useState, useEffect} from 'react';
import AtplLogo from '../images/AtpLab/atp_lab_logo.png';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import {Stack, Typography} from '@mui/material';
import doltorBlueLogo from '../assets/doktorConnect/doktor_connect_blue_logo .png';
import {ATPLBackButton} from '../components/ATPlab/AtplBackBtn';
import HelloHealthLogo from '../images/helloHealthlogo.png';
// Organization IDs
export const ORGANIZATION_IDS = {
  DEFAULT: 0,
  DOKTOR_CONNECT: 1,
  ATP: 2,
  HELLO_HEALTH: 3,
};

// Client types mapping to org IDs
export const CLIENT_TYPES = {
  DEFAULT: 'DEFAULT',
  DOKTOR_CONNECT: 'DOKTOR_CONNECT',
  ATP: 'ATP',
  HELLO_HEALTH: 'HELLO_HEALTH',
};

// Mapping of organization IDs to client types
export const ORG_TO_CLIENT_TYPE = {
  [ORGANIZATION_IDS.DEFAULT]: CLIENT_TYPES.DEFAULT,
  [ORGANIZATION_IDS.DOKTOR_CONNECT]: CLIENT_TYPES.DOKTOR_CONNECT,
  [ORGANIZATION_IDS.ATP]: CLIENT_TYPES.ATP,
  [ORGANIZATION_IDS.HELLO_HEALTH]: CLIENT_TYPES.HELLO_HEALTH,
};

const defaultBackIcon = (
  <>
    <img src="/others/back.svg" alt="back-icon" />
    <Typography color="#72D8DA" variant="p" component="p" fontWeight="600" fontSize="14px" paddingLeft="5px">
      Back
    </Typography>
  </>
);
const atplBackBtn = (
  <Stack width="100%" textAlign="start" padding="2px 0px">
    <ATPLBackButton />
  </Stack>
);

const doktorBackBtn = (
  <Stack width="100%" textAlign="start" padding="2px 0px">
    <ArrowBackIosNewIcon fill="black" sx={{fontSize: 19, color: 'black'}} />
  </Stack>
);

export const clientConfig = {
  [CLIENT_TYPES.DEFAULT]: {
    orgId: ORGANIZATION_IDS.DEFAULT,
    colors: {
      primary: '#72D8DA',
      secondary: '#515151',
      background: '#fff',
      text: '#000',
      buttonText: '#fff',
    },
    urls: {
      nextButtonUrl: '/thank_you',
    },
    logos: {
      main: mainLogo,
      height: 80,
    },
    symptomChecker: {
      symptomCheckerBarColor: '#72D8DA',
      symptomMatchTextColor: '#535252',
    },
    socialButtons: {
      isSocialIconForClients: false,
      background: '#EAF9F9',
      color: '#72D8DA',
      isBgRequired: true,
    },
    button: {
      background: '#72D8DA',
      hover: '#5fb9bb',
    },
    backButton: defaultBackIcon,
    scrollableDateInputColors: {
      selectedInputBgColor: 'rgba(114, 216, 218, 0.20)',
      selectedTextColor: '#35C6C9',
      unSelctedDateTextColor: 'rgb(164 236 236)',
      OkCancelTextColor: '#35C6C9',
    },
    resultPageSlider: {
      isResultPageSliderVisible: true,
      isResultPageSliderForAnalysisPageVisible: true,
      arrowColor: '#CCCCCC',
      arrowHOverColor: '#CCCCCC',
      movingIndicatorColor: '#72D8DA',
      startIconColorActive: '#00000',
    },
    swiperConfig: {
      isSwiperPagination: false,
      isSwiperNavigation: false,
    },
  },
  [CLIENT_TYPES.DOKTOR_CONNECT]: {
    orgId: ORGANIZATION_IDS.DOKTOR_CONNECT,
    colors: {
      primary: '#0633CB',
      secondary: '#515151',
      background: '#fff',
      text: '#000',
      buttonText: '#fff',
    },
    urls: {
      nextButtonUrl: 'https://doktorconnect.com/ng/',
    },
    logos: {
      main: doltorBlueLogo,
      height: 50,
    },
    symptomChecker: {
      symptomCheckerBarColor: '#0633CB',
      symptomMatchTextColor: '#616161',
    },
    socialButtons: {
      isSocialIconForClients: true,
      isBgRequired: false,
      background: 'transparent',
      color: '#0633CB',
    },
    button: {
      background: '#0633CB',
      hover: '#052ab0',
    },
    resultPageSlider: {
      isResultPageSliderVisible: true,
      isResultPageSliderForAnalysisPageVisible: true,
      arrowColor: '#0633CB',
      arrowHOverColor: '#0633CB',
      movingIndicatorColor: '#0633CB',
      startIconColorActive: '#0633CB',
    },
    swiperConfig: {
      isSwiperPagination: false,
      isSwiperNavigation: false,
    },
    backButton: doktorBackBtn,
  },
  [CLIENT_TYPES.ATP]: {
    orgId: ORGANIZATION_IDS.ATP,
    colors: {
      primary: '#ee5c36', //Orange
      secondary: '#515151',
      background: '#fff',
      text: '#000',
      buttonText: '#fff',
    },
    urls: {
      nextButtonUrl: 'https://atplab.com',
    },
    logos: {
      main: AtplLogo,
      height: '28px',
    },
    symptomChecker: {
      symptomCheckerBarColor: '#F15C30',
      symptomMatchTextColor: '#A1A0A0',
    },
    socialButtons: {
      isSocialIconForClients: true,
      // background: '#0633CB',
      // color: '#fff',
      background: '#f3e4e0',
      isBgRequired: true,
      color: '#F15C30', // orange color icons
    },
    button: {
      background: '#ee5c36',
      hover: '#ee5c36',
    },
    backButton: atplBackBtn,
    scrollableDateInputColors: {
      selectedInputBgColor: 'rgba(161, 160, 160, 0.2)',
      selectedTextColor: '#000',
      unSelctedDateTextColor: 'grey',
      OkCancelTextColor: '#F15C30',
    },
    resultPageSlider: {
      isResultPageSliderVisible: true,
      isResultPageSliderForAnalysisPageVisible: true,
      arrowColor: '#ff5722',
      arrowHOverColor: 'ff5722',
      movingIndicatorColor: '#ff5722',
      startIconColorActive: '#ffc107',
    },
    swiperConfig: {
      isSwiperPagination: false,
      isSwiperNavigation: false,
    },
  },
  [CLIENT_TYPES.HELLO_HEALTH]: {
    orgId: ORGANIZATION_IDS.HELLO_HEALTH,
    colors: {
      primary: '#F5733B', //Orange
      secondary: '#515151',
      background: '#fff',
      text: '#000',
      buttonText: '#fff',
    },
    urls: {
      nextButtonUrl: 'https://www.gethellohealth.com/pages/guide-me-to-greatness-schedule-a-call-with-pamela-wirth',
    },
    logos: {
      main: HelloHealthLogo,
      height: '28px',
    },
    symptomChecker: {
      symptomCheckerBarColor: '#F5733B',
      symptomMatchTextColor: '#A1A0A0',
    },
    socialButtons: {
      isSocialIconForClients: true,
      // background: '#0633CB',
      // color: '#fff',
      background: '#FEEFEA',
      isBgRequired: true,
      color: '#F5733B', // orange color icons
    },
    button: {
      background: '#F5733B',
      hover: '#F5733B',
    },
    backButton: atplBackBtn,
    scrollableDateInputColors: {
      selectedInputBgColor: 'rgba(161, 160, 160, 0.2)',
      selectedTextColor: '#000',
      unSelctedDateTextColor: 'grey',
      OkCancelTextColor: '#F15C30',
    },
    resultPageSlider: {
      isResultPageSliderVisible: true,
      isResultPageSliderForAnalysisPageVisible: true,
      arrowColor: '#F5733B',
      arrowHOverColor: '#F5733B',
      movingIndicatorColor: '#F5733B',
      startIconColorActive: '#ffc107',
    },
    swiperConfig: {
      isSwiperPagination: false,
      isSwiperNavigation: false,
    },
  },
};

/**
 * Get client type from organization ID
 * @param {number} orgId - Organization ID
 * @returns {string} Client type
 */
export const getClientTypeFromOrgId = orgId => {
  return ORG_TO_CLIENT_TYPE[orgId] || CLIENT_TYPES.DEFAULT;
};

/**
 * Get client configuration using organization ID
 * @param {number} orgId - Organization ID
 * @returns {Object} Client configuration
 */
export const getClientConfigFromOrgId = orgId => {
  const clientType = getClientTypeFromOrgId(orgId);
  return clientConfig[clientType] || clientConfig[CLIENT_TYPES.DEFAULT];
};

/**
 * Get client configuration using client type
 * @param {string} clientType - Client type
 * @returns {Object} Client configuration
 */
export const getClientConfig = (clientType = CLIENT_TYPES.DEFAULT) => {
  return clientConfig[clientType] || clientConfig[CLIENT_TYPES.DEFAULT];
};

/**
 * Hook to get client configuration from localStorage
 * @returns {Object} Client configuration and client type
 */
export const useClientConfig = () => {
  const [config, setConfig] = useState(clientConfig[CLIENT_TYPES.DEFAULT]);
  const [clientType, setClientType] = useState(CLIENT_TYPES.DEFAULT);

  useEffect(() => {
    const storedOrgId = localStorage.getItem('organization_id');
    if (storedOrgId) {
      const orgId = parseInt(storedOrgId);
      const type = getClientTypeFromOrgId(orgId);
      setClientType(type);
      setConfig(clientConfig[type]);
    }
  }, []);

  return {config, clientType};
};

export const useClientSetup = () => {
  const [clientType, setClientType] = useState(CLIENT_TYPES.DEFAULT);
  const [config, setConfig] = useState(getClientConfig(CLIENT_TYPES.DEFAULT));

  useEffect(() => {
    const determineClientType = () => {
      // Get organization ID from localStorage
      const storedOrgId = localStorage.getItem('organization_id');

      if (storedOrgId) {
        // Convert stored org ID to number
        const orgId = parseInt(storedOrgId);
        // Get client type based on org ID
        return getClientTypeFromOrgId(orgId);
      }

      // If no org ID found, set default org ID and return default client type
      localStorage.setItem('organization_id', ORGANIZATION_IDS.DEFAULT.toString());
      return CLIENT_TYPES.DEFAULT;
    };

    const newClientType = determineClientType();
    setClientType(newClientType);
    setConfig(getClientConfig(newClientType));
  }, []); // Empty dependency array means this runs once on mount

  return {clientType, setClientType, config};
};
